module.exports = __webpack_public_path__ + "img/person_dialog_bg.a94d7a6f.png";